import React, { FC } from 'react';
import { IconProps } from './IconInterface';

export const EventsIcon: FC<IconProps> = ({ fill, width, height }: IconProps) => (
  <svg id="Layer_1" viewBox="0 0 32 32" width={width} height={height} fill={fill}>
    <path
      d="M27.43,2.86H25.14V1.71a1.14,1.14,0,0,0-2.28,0V2.86H9.14V1.71a1.14,1.14,0,0,0-2.28,0V2.86H4.57A4.58,4.58,0,0,0,0,7.43V26.86a4.58,4.58,0,0,0,4.57,4.57H27.43A4.58,4.58,0,0,0,32,26.86V7.43A4.58,4.58,0,0,0,27.43,2.86ZM2.29,7.43A2.29,2.29,0,0,1,4.57,5.14H6.86V6.29a1.14,1.14,0,0,0,2.28,0V5.14H22.86V6.29a1.14,1.14,0,0,0,2.28,0V5.14h2.29a2.29,2.29,0,0,1,2.28,2.29V8.57H2.29ZM29.71,26.86a2.28,2.28,0,0,1-2.28,2.28H4.57a2.28,2.28,0,0,1-2.28-2.28v-16H29.71Z"
      fill="current"
    />
    <path d="M8,17.71H24a1.14,1.14,0,0,0,0-2.28H8a1.14,1.14,0,1,0,0,2.28Z" fill="current" />
    <path d="M8,24.57H24a1.14,1.14,0,0,0,0-2.28H8a1.14,1.14,0,1,0,0,2.28Z" fill="current" />
  </svg>
);
